import { createSelector } from '@ngrx/store';
import { surveyCreationFeature } from '../survey-creation.feature';
import { DEFAULT_CORE_CHILD_STATE } from '../survey-creation-state.constants';
import { resolveActiveCoreChildKey } from './utils/core-children.helper';

const { selectCore } = surveyCreationFeature;

export const selectRootSurveyId = createSelector(
  selectCore,
  (state) => state.rootSurveyId,
);

export const selectActiveChildKey = createSelector(
  selectCore,
  (state) => state.activeChildKey,
);

export const selectKind = createSelector(selectCore, (state) => state.kind);

export const selectCoreChildren = createSelector(
  selectCore,
  (state) => state.children,
);

const selectActiveCoreChild = createSelector(selectCore, (state) => {
  const key = resolveActiveCoreChildKey(state);
  return state.children[key] ?? DEFAULT_CORE_CHILD_STATE;
});

export const selectSurvey = createSelector(
  selectActiveCoreChild,
  ({ survey }) => survey,
);

export const selectSurveyId = createSelector(
  selectSurvey,
  (survey) => survey?.id ?? null,
);

export const selectIsSurveyLoaded = createSelector(
  selectSurvey,
  (survey) => !!survey,
);

export const selectError = createSelector(
  selectActiveCoreChild,
  ({ error }) => error,
);
